/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Mailbox_Reconnect_RequiredInputs */

const fr_api_mailbox_reconnect_required = /** @type {(inputs: Api_Mailbox_Reconnect_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’autorisation de la boîte des factures n’est plus valide. Reconnectez-la.`)
};

const en_api_mailbox_reconnect_required = /** @type {(inputs: Api_Mailbox_Reconnect_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The invoice mailbox authorization is no longer valid. Reconnect it.`)
};

/**
* | output |
* | --- |
* | "The invoice mailbox authorization is no longer valid. Reconnect it." |
*
* @param {Api_Mailbox_Reconnect_RequiredInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_mailbox_reconnect_required = /** @type {((inputs?: Api_Mailbox_Reconnect_RequiredInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Mailbox_Reconnect_RequiredInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_mailbox_reconnect_required(inputs)
	return fr_api_mailbox_reconnect_required(inputs)
});